import 'src/styles/ui/notice-card.css';

import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * The shared card for anything that interrupts an action: a warning to review,
 * a reassurance, or a hard block. One shape so the operator learns it once.
 *
 * @example
 * <NoticeCard variant="danger" icon={faBan} tile="notice-tile--danger" title="Cannot load">
 *   ...detail behind the expander
 * </NoticeCard>
 */
const NoticeCard = ({
  variant,
  icon,
  tile,
  title,
  sub,
  moreMeta,
  moreLabel,
  isOpen,
  onToggle,
  children,
  action,
  className,
}) => (
  <div
    className={classNames(
      'notice-card',
      { [`notice-card--${variant}`]: variant, 'notice-card--open': isOpen },
      className
    )}
  >
    <div className={classNames('notice-card__head', { 'notice-card__head--tight': !sub })}>
      <span className={classNames('notice-tile', tile)}>
        <FontAwesomeIcon icon={icon} />
      </span>
      <div className='notice-card__main'>
        <div className='notice-card__title'>{title}</div>
        {sub && <div className='notice-card__sub'>{sub}</div>}
      </div>
    </div>

    {moreLabel && (
      <button type='button' className='notice-card__more' onClick={onToggle}>
        <span className='notice-card__more-label'>{isOpen ? 'Hide detail' : moreLabel}</span>
        {moreMeta && <span className='notice-card__pill'>{moreMeta}</span>}
        <FontAwesomeIcon icon={faChevronDown} />
      </button>
    )}

    {isOpen && children}
    {action && <div className='notice-card__action'>{action}</div>}
  </div>
);

NoticeCard.propTypes = {
  variant: PropTypes.oneOf(['ok', 'danger']),
  icon: PropTypes.object.isRequired,
  tile: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  sub: PropTypes.node,
  moreMeta: PropTypes.string,
  moreLabel: PropTypes.string,
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  children: PropTypes.node,
  action: PropTypes.node,
  className: PropTypes.string,
};

NoticeCard.defaultProps = {
  variant: null,
  sub: null,
  moreMeta: null,
  moreLabel: null,
  isOpen: false,
  onToggle: null,
  children: null,
  action: null,
  className: null,
};

export default NoticeCard;
